import { OptionVariationData } from '../../../data/model';
import { FilterState } from '../../../shared/FilterState/FilterState';
import { IFabricOptionVariationFilter } from '../../FabricOptionState';

export default class FacetFilterState extends FilterState implements IFabricOptionVariationFilter {
  public get selectedProperties() {
    return this.availableProperties.filter((x) => x.selected);
  }

  public isSatisfied(variation: OptionVariationData): boolean {
    return this.selectedProperties.some((s) => variation.properties.some((p) => p.valueId === s.data.valueId));
  }
}
